import type { IconProps } from './types';

export const UploadIcon = (props: IconProps) => {
  const {
    width = 16,
    height = 19,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 19"
      fill="none"
      className={className}
    >
      <path
        d="M8.26924 13.8077V1.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.26923 7.5L8.26923 1.5L14.2692 7.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0385 17.5H1.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
